import React, { useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import SimulationService from "../../services/simulations.service";

import DataTableDisplay from "../../component/dataTableDisplay";
import { showErrorToaster } from "../../component/toasters/error";
import Loading from "../../component/loading";
const simulationService = new SimulationService();

function SimulationListe() {
  const [simulations, setSimulations] = useState([]);
  console.log("simulations", simulations);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);

  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await simulationService?.getAllSimulation();
      setSimulations(res?.data);
      console.log(simulations, "simulations");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const columnsSimulation = [
    {
      name: "Frais Gestion Euro ",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.fraisGestionEuroFr != null && row?.fraisGestionEuroFr}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Base Disponible",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.baseDisponibleFr != null && row?.baseDisponibleFr}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Salaire Brut",
      selector: (row) => (
        <div className="table-text">
          {row?.salaireBrutFr != null && row?.salaireBrutFr}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Salaire Net",
      selector: (row) => (
        <div className="table-text">
          {row?.salaireNetFr != null && row?.salaireNetFr}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Configuration",
      selector: (row) => {
        if (row?.configFr) return <span className="table-text">FR</span>;
        if (row?.configUk) return <span className="table-text">UK</span>;
        if (row?.configLux) return <span className="table-text">LUX</span>;
        return <span className="table-text text-muted">Non défini</span>;
      },
      sortable: true,
      hide: "md",
    },
    {
      name: "Contact",
      selector: (row) => (
        <div className="table-text">
          {row?.contact?.email != null && row?.contact?.email}
        </div>
      ),
      sortable: true,
      hide: "md",
    },
    {
      name: "Actions", // Column title for actions like View or Delete
      selector: (row) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {/* Eye Button */}
          <button
            type="button"
            className=" btn-link detailsbutton p-0"
            style={{ borderRadius: "14px" }}
            onClick={() => {
              if (row && row?._id) {
                navigate(`/detailsSimulation/${row?._id}`);
              } else {
                console.error("Row or row.id is undefined");
              }
            }}>
            <label className=" action-icon detailsicons" title="View Details">
              Détails
            </label>
          </button>
        </div>
      ),
    },
  ];
  const [hasMore, setHasMore] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (simulations && simulations?.length > 0) {
      setFilteredData(simulations.slice(0, 3));
    }
  }, [simulations]);
  async function fetchMoreData() {
    setTimeout(() => {
      if (filteredData.length >= simulations?.length) {
        setHasMore(false);
        return;
      } else {
        new Promise((resolve) => setTimeout(resolve, 500));

        setFilteredData((prevItems) => {
          // Add real formation data instead of dummy items
          const newItems = simulations.slice(
            prevItems.length,
            prevItems.length + 3
          );
          return [...prevItems, ...newItems];
        });
      }
    }, 500);
  }

  return (
    <section className="usersPage card-globale">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3 className="title-liste-admin">Simulations liste</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-0 my-md-5  justify-content-center align-items-center"></div>
        ) : (
          <div className="my-5 py-2">
            {isMobile > 599 ? (
              <DataTableDisplay
                columns={columnsSimulation}
                data={simulations}
              />
            ) : (
              <>
                {" "}
                <InfiniteScroll
                  dataLength={filteredData.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  loader={
                    <div className="d-flex justify-content-center">
                      <Loading />
                    </div>
                  }
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>Plus de données à charger</b>
                    </p>
                  }>
                  {filteredData.map((item) => ({
                    /*   <ContactResponsiveCards
                      key={item.id} // Ensure the key is unique for each item
                      contacts={item}
                      loadData={loadData}
                    /> */
                  }))}
                </InfiniteScroll>
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default SimulationListe;
